var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_vm._m(0),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ring w-full mx-auto max-w-xs"},[_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }